const generos = [
  { id: "DON", text: "Hombre" },
  { id: "DOÑA", text: "Mujer" },
  { id: "OTRO", text: "Otro" },
  { id: "NO_CONTESTA", text: "Prefiero no contestar" },
];

export const generosMap = generos.reduce((prev, value) => {
  return {
    ...prev,
    [value.id]: value.text,
  };
}, {});

export { generos };
